/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotOrgMetricsRequest {
    getFixupPrototypeFunction() { return CopilotOrgMetricsRequest.fixupPrototype; }

    static newInstance(model: Partial<CopilotOrgMetricsRequest>): CopilotOrgMetricsRequest {
        let obj = Object.assign(new CopilotOrgMetricsRequest(), model);
        CopilotOrgMetricsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotOrgMetricsRequest>): CopilotOrgMetricsRequest {
        if (!model) return null;
        return CopilotOrgMetricsRequest.newInstance(<CopilotOrgMetricsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotOrgMetricsRequest) {
        if (!obj) return;

        models.CopilotOrgMetricsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotOrgMetricsRequest): boolean {
        Object.setPrototypeOf(obj, CopilotOrgMetricsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Query expression to filter results.
     */
    query: models.QueryOperator;

}
